class integrationServices {

    constructor($resource,SERVICE_URL_CONSTANT) {

       
          var services = $resource(SERVICE_URL_CONSTANT.dataExecution +'/:route',{},{            
            getExecutionDetails:{
              method:'GET',
              params : {
                route: 'getExecutablefeatures'
              }
            },
            setExecutionDetails:{
              method:'POST',
              params : {
                route: 'setExecutionDetails'
              }
            },
            pingEtlExecutable:{
              method:'GET',
              params : {
                route: 'pingEtlExecutable'
              }
            }

          });


          return {
            services : services
          };
        }

    }

  integrationServices.$inject=['$resource','SERVICE_URL_CONSTANT']

  export default  angular.module('services.integrationServices', [])
  .service('integrationServices', integrationServices)
  .name;



// WEBPACK FOOTER //
// ./src/app/integration-front/integrationServices.js